import { createContext } from 'react';
import { BuyFlowStep, CheckoutFlowPage } from '@checkout/utils/Constants';
import { BsAction, BsContext } from '@app/transaction';
import type { LegacyProduct, LegacyChildProduct } from '@app/types';

export type ContextProps = {
  context?: BsContext;
  page?: CheckoutFlowPage;
  product?: LegacyProduct | LegacyChildProduct;
  action?: BsAction;
  step?: BuyFlowStep;
  showSizeChart?: boolean;
};

interface CreateContextArgs {
  data: Partial<ContextProps>;
  setData?: (data: Record<string, any>) => void;
}

const HeaderContext = createContext<CreateContextArgs>({
  data: {},
  setData: undefined,
});

HeaderContext.displayName = 'HeaderContext';

export default HeaderContext;
